import { FC } from 'react';

import { useRegistrationStore } from 'page/NotificationPage/hooks';
import { useCustomerStore } from 'page/NotificationPage/hooks/useCustomersStore';
import { NotificationHeaderView } from 'page/NotificationPage/components/NotificationHeaderView';

export const NotificationHeader: FC = () => {
  const { openModal } = useRegistrationStore();
  const { fetchCustomers } = useCustomerStore();

  /**
   * お知らせ新規登録ボタンをクリックしたときの処理
   */
  const handleClickRegistration = () => {
    openModal();
    void fetchCustomers();
  };

  return (
    <NotificationHeaderView handleClickRegistration={handleClickRegistration} />
  );
};
